// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2424":"e554a6be","3460":"a20f54aa"}[chunkId] + ".chunk.css";
};